import axios from 'axios'

const basePath = 'https://store.qnbar.com/oss'

/**
 * 获取青柠首映、青柠电影等白名单
 * @returns 
 */
export function getWhiteList() {
    return axios.get(basePath + '/ui_theme/whiteList.json')
        .then(res => {
            return res.data
        })
}

/**
 * 获取操作权限（如：上传、文本编辑、消息管理）相关白名单
 * @returns 
 */
 export function getAuthList() {
    return axios.get(basePath + '/mix/authList.json')
        .then(res => {
            return res.data
        })
}

export default {
    getWhiteList,
    getAuthList
}


// WEBPACK FOOTER //
// ./src/api/theme.js